import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import { SpaceBetweenRowContainer, FlexEndContainer, FlexColumn } from '../styles/Containers'
import BodyText from '../styles/Text'
import DraftBillRow from './DraftBillRow'

const Empty = styled(BodyText)`
  display: flex;
  justify-content: center;
  padding-top: 15px;
`

const Headings = styled(SpaceBetweenRowContainer)`
  padding: 0px 30px;
  align-self: stretch;
  margin-right: 47px;
`

const Item = styled.div`
  flex-basis: 16%;
  font-size: 16px;
`

const LastItem = styled(FlexEndContainer)`
  min-width: 120px;
  flex-basis: 20%;
`

const Placeholder = styled.div`
  width: 29px;
`

function DraftBillTable({
  bills,
  users = [],
  onlyApplicationFeeAllowed = false,
  editingBill,
  expandedBillId,
  onBillUpdate = () => {},
  handleUpdateEditingBill = () => {}
}) {
  return (
    <FlexColumn gap="15px">
      <Headings>
        <Item>Assigned</Item>
        <Item>ID</Item>
        <Item>Type</Item>
        <Item>Amount</Item>
        <Item>Fee Last Modified</Item>
        <LastItem>Status</LastItem>
        <Placeholder />
      </Headings>

      {bills && bills.length > 0 ? (
        bills.map(bill => (
          <DraftBillRow
            key={bill.id}
            bill={bill}
            users={users}
            onlyApplicationFeeAllowed={onlyApplicationFeeAllowed}
            editingBill={editingBill}
            defaultExpanded={expandedBillId === bill.id}
            onBillUpdate={onBillUpdate}
            handleUpdateEditingBill={handleUpdateEditingBill}
          />
        ))
      ) : (
        <Empty>No bills available</Empty>
      )}
    </FlexColumn>
  )
}

DraftBillTable.propTypes = {
  bills: PropTypes.array.isRequired,
  users: PropTypes.array,
  editingBill: PropTypes.object,
  expandedBillId: PropTypes.string,
  onlyApplicationFeeAllowed: PropTypes.bool,
  onBillUpdate: PropTypes.func,
  handleUpdateEditingBill: PropTypes.func
}

export default DraftBillTable
